export const environment = {
  production: true,
  apiUrl: 'https://api.avtotime02.ru',
  sentry: {
    dsn: '',
    environment: 'production',
    release: 'latest',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.1,
    tracePropagationTargets: ['https://api.avtotime02.ru'],
  },
};
